import { ReactElement } from 'react';
import { NextPageWithLayout } from '../_app';
import { Layout } from '../../components/Layout';
import { ApiTokenPage } from '../../views/ApiToken';
import { Page } from '../../components/Page';

export const ApiToken: NextPageWithLayout = () => {
  return (
    <Page title="Api Token">
      <ApiTokenPage />
    </Page>
  );
};

ApiToken.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>;
};

export default ApiToken;
